import { toast } from "react-toastify";


export const getPayoutStatus = (status: string) => {
    let text = '';
    switch (status) {
        case 'PENDING':
            text = 'Pending'
            break;
        case 'INITIATED':
            text = 'Initiated'
            break;
        case 'PROCESSED':
            text = 'Processed'
            break;
        case 'REJECTED':
            text = 'Rejected'
            break;
        case 'RETURN':
            text = 'Returned'
            break;
        case 'SUCCESS':
            text = 'Success'
            break;
        default:
            break;
    }
    return text;
}

export const getPayoutStatusColor = (status: string) => {
    let color = '';
    switch (status) {
        case 'INITIATED':
            color = 'color-orange'
            break;
        case 'PROCESSED':
            color = 'color-primary'
            break;
        case 'REJECTED':
        case 'RETURN':
            color = 'color-red'
            break;
        default:
            break;
    }
    return color;
}

export function copyText(text: string) {
    navigator.clipboard.writeText(text)
        .then(() => {
            toast.success('Copied to clipboard')
        })
        .catch(err => {
            console.error("Failed to copy: ", err);
        });
}
